var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9483 0C20.5421 3.54575 25.5955 5.22324 29.9325 4.82667C30.6899 20.1468 25.0323 29.1943 15.0063 32.9702C5.32421 29.436 -0.402653 20.7779 0.0220859 4.59432C5.11332 4.86075 10.1082 3.76013 14.9483 0ZM9.06449 17.9166C8.74788 17.6456 8.71085 17.1691 8.98158 16.8522C9.25284 16.5353 9.72937 16.4985 10.046 16.7693L13.13 19.4189L19.8861 11.9909C20.167 11.6823 20.6449 11.6598 20.9537 11.9404C21.262 12.2211 21.2845 12.699 21.0039 13.0078L13.7541 20.9788C13.4804 21.2796 13.0154 21.3099 12.7044 21.0438L9.06449 17.9166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtection);
export default __webpack_public_path__ + "static/media/IconProtection.0f4b491371850cffaa8a71bfb596324a.svg";
export { ForwardRef as ReactComponent };